/**
 * Global activity event feed for the landing page.
 *
 * Unlike the registry-based domains, each subscriber attaches its own
 * `global_activity` listener and the subscription is NOT replayed after a
 * reconnect — preserved as the long-standing contract for this feed (its
 * consumers re-subscribe on mount rather than relying on replay).
 */

import { WebSocketClient } from '../client'

export class GlobalEventsLiveApi {
  constructor(private readonly client: WebSocketClient) {}

  /**
   * Subscribe to the global_events room to receive all activity events
   * across all projects. Returns a cleanup function that leaves the room
   * and detaches this subscriber's listener.
   */
  subscribeToGlobalEvents(callback: (data: unknown) => void): () => void {
    if (!this.client.hasSocket()) {
      console.warn('WebSocket not connected. Call connect() first.')
      return () => {}
    }

    console.log('Subscribing to global events')

    this.client.emitIfSocket('subscribe_global', {})

    const handleGlobalEvent = (event: unknown) => {
      console.log('Received global activity event:', event)
      callback(event)
    }

    const detach = this.client.on('global_activity', handleGlobalEvent)

    return () => {
      if (!this.client.hasSocket()) return
      console.log('Unsubscribing from global events')
      this.client.emitIfSocket('unsubscribe_global', {})
      detach()
    }
  }
}
